import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import FullWidthList from 'routes/Products/components/FullWidthList';

class CollectionsListPage extends PureComponent {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return <FullWidthList {...this.props} />;
  }
}

CollectionsListPage.propTypes = {
  id: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  Children: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  data: PropTypes.shape({}).isRequired
};

export default CollectionsListPage;
